/**
 * Use this method to override AccessiBe inline styles and remove classes
 * @param {Object} params
 * @param {string|HTMLElement} params.targetContainer Element to attach the observables to. 
 * @param {function()} params.targetFilter Function that elements to consider when a change happens on targetContainer.
 * @param {string} params.selectorQuery Query to get parent element 
 * @param {string} params.selectorItemsQuery Query to find child elements from parent. 
 * @param {string[]} params.toRemove List of classes to remove from each element.
 * @param {string} params.toStyle String which will override or delete inline style from the element.
 * @returns {void}
 * 
 */
function setAccessibeListeners({targetContainer, targetFilter, selectorQuery, selectorItemsQuery, toRemove, toStyle = null}) {
	const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    const isAccessiBeModifyingStyle = mutationList.filter(targetFilter).length;
    if (isAccessiBeModifyingStyle) {
      removeAccessiBeStyles({
        selectorQuery,
        selectorItemsQuery,
        toRemove,
        toStyle,
      });
    }
  };
  const containerNode = targetContainer ? document.querySelector(targetContainer) : this
	const observer = new MutationObserver(callback);
	observer.observe(containerNode, config);
}

function removeAccessiBeStyles({selectorQuery,selectorItemsQuery, toRemove, toStyle}) {
	const container = document.querySelector(selectorQuery);
  if (!container) {
    console.log("container not found by acsb-callback");
    return;
  }
  const elements = container.querySelectorAll(selectorItemsQuery);
  elements.forEach((e) => {
    toRemove.forEach((clsItem) => e.classList.remove(clsItem));
    e.style = toStyle;
    e.removeAttribute("data-acsb-clickable");
  });
}

if (global.isAccessiBeEnabled) {
	const acsbFilterFunction = (mutation) =>
    mutation.type === "attributes" &&
    mutation.target.classList.contains("acsb-contrast");

  setAccessibeListeners({
    targetContainer: ".trove-variants-container",
    targetFilter: acsbFilterFunction,
    selectorQuery: "variant-radios",
    selectorItemsQuery: "label",
    toRemove: ["acsb-outline-contrast", "acsb-contrast"],
    toStyle: "",
  });
}
